// Generated by purs version 0.13.0
"use strict";
var $foreign = require("./foreign.js");
var Control_Alt = require("../Control.Alt/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Control_Monad_Except = require("../Control.Monad.Except/index.js");
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans/index.js");
var Control_Semigroupoid = require("../Control.Semigroupoid/index.js");
var Data_Bifunctor = require("../Data.Bifunctor/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Nullable = require("../Data.Nullable/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Variant = require("../Data.Variant/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Effect_Uncurried = require("../Effect.Uncurried/index.js");
var Effect_Unsafe = require("../Effect.Unsafe/index.js");
var Foreign = require("../Foreign/index.js");
var Foreign_Index = require("../Foreign.Index/index.js");
var Foreign_Object = require("../Foreign.Object/index.js");
var Global_Unsafe = require("../Global.Unsafe/index.js");
var Partial_Unsafe = require("../Partial.Unsafe/index.js");
var Record = require("../Record/index.js");
var Record_Builder = require("../Record.Builder/index.js");
var Type_Data_RowList = require("../Type.Data.RowList/index.js");
var WriteForeignVariant = function (writeVariantImpl) {
    this.writeVariantImpl = writeVariantImpl;
};
var WriteForeignFields = function (writeImplFields) {
    this.writeImplFields = writeImplFields;
};
var WriteForeign = function (writeImpl) {
    this.writeImpl = writeImpl;
};
var ReadForeignVariant = function (readVariantImpl) {
    this.readVariantImpl = readVariantImpl;
};
var ReadForeignFields = function (getFields) {
    this.getFields = getFields;
};
var ReadForeign = function (readImpl) {
    this.readImpl = readImpl;
};
var writeVariantImpl = function (dict) {
    return dict.writeVariantImpl;
};
var writeImplFields = function (dict) {
    return dict.writeImplFields;
};
var writeImpl = function (dict) {
    return dict.writeImpl;
};
var writeJSON = function (dictWriteForeign) {
    var $85 = writeImpl(dictWriteForeign);
    return function ($86) {
        return Global_Unsafe.unsafeStringify($85($86));
    };
};
var writeForeignVariant = function (dictRowToList) {
    return function (dictWriteForeignVariant) {
        return new WriteForeign(function (variant) {
            return writeVariantImpl(dictWriteForeignVariant)(Type_Data_RowList.RLProxy.value)(variant);
        });
    };
};
var writeForeignString = new WriteForeign(Foreign.unsafeToForeign);
var writeForeignObject = function (dictWriteForeign) {
    return new WriteForeign((function () {
        var $87 = Foreign_Object.mapWithKey(Data_Function["const"](writeImpl(dictWriteForeign)));
        return function ($88) {
            return Foreign.unsafeToForeign($87($88));
        };
    })());
};
var writeForeignNumber = new WriteForeign(Foreign.unsafeToForeign);
var writeForeignNullable = function (dictWriteForeign) {
    return new WriteForeign((function () {
        var $89 = Data_Maybe.maybe(Foreign.unsafeToForeign(Data_Nullable.toNullable(Data_Maybe.Nothing.value)))(writeImpl(dictWriteForeign));
        return function ($90) {
            return $89(Data_Nullable.toMaybe($90));
        };
    })());
};
var writeForeignInt = new WriteForeign(Foreign.unsafeToForeign);
var writeForeignForeign = new WriteForeign(Control_Category.identity(Control_Category.categoryFn));
var writeForeignChar = new WriteForeign(Foreign.unsafeToForeign);
var writeForeignBoolean = new WriteForeign(Foreign.unsafeToForeign);
var writeForeignArray = function (dictWriteForeign) {
    return new WriteForeign(function (xs) {
        return Foreign.unsafeToForeign(Data_Functor.map(Data_Functor.functorArray)(writeImpl(dictWriteForeign))(xs));
    });
};
var write = function (dictWriteForeign) {
    return writeImpl(dictWriteForeign);
};
var $$undefined = $foreign["_undefined"];
var writeForeignMaybe = function (dictWriteForeign) {
    return new WriteForeign(Data_Maybe.maybe($$undefined)(writeImpl(dictWriteForeign)));
};
var recordWriteForeign = function (dictRowToList) {
    return function (dictWriteForeignFields) {
        return new WriteForeign(function (rec) {
            var steps = writeImplFields(dictWriteForeignFields)(Type_Data_RowList.RLProxy.value)(rec);
            return Foreign.unsafeToForeign(Record_Builder.build(steps)({}));
        });
    };
};
var readVariantNil = new ReadForeignVariant(function (v) {
    return function (v1) {
        return Foreign.fail(new Foreign.ForeignError("Unable to match any variant member."));
    };
});
var readVariantImpl = function (dict) {
    return dict.readVariantImpl;
};
var readString = new ReadForeign(Foreign.readString);
var readNumber = new ReadForeign(Foreign.readNumber);
var readInt = new ReadForeign(Foreign.readInt);
var readImpl = function (dict) {
    return dict.readImpl;
};
var readMaybe = function (dictReadForeign) {
    return new ReadForeign((function () {
        var readNullOrUndefined = function (v) {
            return function (value) {
                if (Foreign.isNull(value) || Foreign.isUndefined(value)) {
                    return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_Maybe.Nothing.value);
                };
                return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Maybe.Just.create)(v(value));
            };
        };
        return readNullOrUndefined(readImpl(dictReadForeign));
    })());
};
var readNullable = function (dictReadForeign) {
    return new ReadForeign(function (o) {
        var reformat = function (error) {
            if (error instanceof Foreign.TypeMismatch) {
                return new Foreign.TypeMismatch("Nullable " + error.value0, error.value1);
            };
            return error;
        };
        return Control_Monad_Except.withExcept(Data_Functor.map(Data_List_Types.functorNonEmptyList)(reformat))(Control_Bind.bindFlipped(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Data_Functor.map(Data_Functor.functorFn)(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Nullable.toNullable))(Data_Traversable.traverse(Data_Traversable.traversableMaybe)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(readImpl(dictReadForeign))))(Foreign.readNull(o)));
    });
};
var readObject = function (dictReadForeign) {
    return new ReadForeign((function () {
        var readObject$prime = function (value) {
            if (Foreign.tagOf(value) === "Object") {
                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Foreign.unsafeFromForeign(value));
            };
            if (Data_Boolean.otherwise) {
                return Foreign.fail(new Foreign.TypeMismatch("Object", Foreign.tagOf(value)));
            };
            throw new Error("Failed pattern match at Simple.JSON (line 185, column 7 - line 185, column 51): " + [ value.constructor.name ]);
        };
        return Control_Bind.composeKleisliFlipped(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))((function () {
            var $91 = Data_Traversable.sequence(Foreign_Object.traversableObject)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
            var $92 = Foreign_Object.mapWithKey(Data_Function["const"](readImpl(dictReadForeign)));
            return function ($93) {
                return $91($92($93));
            };
        })())(readObject$prime);
    })());
};
var readForeignVariant = function (dictRowToList) {
    return function (dictReadForeignVariant) {
        return new ReadForeign(function (o) {
            return readVariantImpl(dictReadForeignVariant)(Type_Data_RowList.RLProxy.value)(o);
        });
    };
};
var readForeign = new ReadForeign(Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity)));
var readFieldsNil = new ReadForeignFields(function (v) {
    return function (v1) {
        return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Control_Category.identity(Record_Builder.categoryBuilder));
    };
});
var readChar = new ReadForeign(Foreign.readChar);
var readBoolean = new ReadForeign(Foreign.readBoolean);
var readArray = function (dictReadForeign) {
    return new ReadForeign(Control_Bind.composeKleisliFlipped(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Data_Traversable.traverse(Data_Traversable.traversableArray)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(readImpl(dictReadForeign)))(Foreign.readArray));
};
var read$prime = function (dictReadForeign) {
    return readImpl(dictReadForeign);
};
var read = function (dictReadForeign) {
    var $94 = readImpl(dictReadForeign);
    return function ($95) {
        return Control_Monad_Except.runExcept($94($95));
    };
};
var readAsForeign = function (dictReadForeign) {
    var $96 = read(dictReadForeign);
    return function ($97) {
        return $96(Foreign.unsafeToForeign($97));
    };
};
var read_ = function (dictReadForeign) {
    var $98 = read(dictReadForeign);
    return function ($99) {
        return Data_Either.hush($98($99));
    };
};
var parseJSON = (function () {
    var $100 = Data_Bifunctor.lmap(Data_Either.bifunctorEither)((function () {
        var $103 = Control_Applicative.pure(Data_List_Types.applicativeNonEmptyList);
        return function ($104) {
            return $103(Foreign.ForeignError.create(Effect_Exception.message($104)));
        };
    })());
    var $101 = Effect_Uncurried.runEffectFn1($foreign["_parseJSON"]);
    return function ($102) {
        return Control_Monad_Except_Trans.ExceptT(Data_Identity.Identity($100(Effect_Unsafe.unsafePerformEffect(Effect_Exception["try"]($101($102))))));
    };
})();
var readJSON = function (dictReadForeign) {
    var $105 = Control_Bind.composeKleisliFlipped(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(readImpl(dictReadForeign))(parseJSON);
    return function ($106) {
        return Control_Monad_Except.runExcept($105($106));
    };
};
var readJSON_ = function (dictReadForeign) {
    var $107 = readJSON(dictReadForeign);
    return function ($108) {
        return Data_Either.hush($107($108));
    };
};
var readJSON$prime = function (dictReadForeign) {
    return Control_Bind.composeKleisliFlipped(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(readImpl(dictReadForeign))(parseJSON);
};
var nilWriteForeignVariant = new WriteForeignVariant(function (v) {
    return function (v1) {
        return Partial_Unsafe.unsafeCrashWith("Variant was not able to be writen row WriteForeign.");
    };
});
var nilWriteForeignFields = new WriteForeignFields(function (v) {
    return function (v1) {
        return Control_Category.identity(Record_Builder.categoryBuilder);
    };
});
var getFields = function (dict) {
    return dict.getFields;
};
var readRecord = function (dictRowToList) {
    return function (dictReadForeignFields) {
        return new ReadForeign(function (o) {
            return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Function.flip(Record_Builder.build)({}))(getFields(dictReadForeignFields)(Type_Data_RowList.RLProxy.value)(o));
        });
    };
};
var consWriteForeignVariant = function (dictIsSymbol) {
    return function (dictWriteForeign) {
        return function (dictCons) {
            return function (dictWriteForeignVariant) {
                return new WriteForeignVariant(function (v) {
                    return function (variant) {
                        var writeVariant = function (value) {
                            return Foreign.unsafeToForeign({
                                type: Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value),
                                value: writeImpl(dictWriteForeign)(value)
                            });
                        };
                        return Data_Variant.on(dictCons)(dictIsSymbol)(Data_Symbol.SProxy.value)(writeVariant)(writeVariantImpl(dictWriteForeignVariant)(Type_Data_RowList.RLProxy.value))(variant);
                    };
                });
            };
        };
    };
};
var consWriteForeignFields = function (dictIsSymbol) {
    return function (dictWriteForeign) {
        return function (dictWriteForeignFields) {
            return function (dictCons) {
                return function (dictLacks) {
                    return function (dictCons1) {
                        return new WriteForeignFields(function (v) {
                            return function (rec) {
                                var rest = writeImplFields(dictWriteForeignFields)(Type_Data_RowList.RLProxy.value)(rec);
                                var value = writeImpl(dictWriteForeign)(Record.get(dictIsSymbol)(dictCons)(Data_Symbol.SProxy.value)(rec));
                                var result = Control_Semigroupoid.compose(Record_Builder.semigroupoidBuilder)(Record_Builder.insert(dictCons1)(dictLacks)(dictIsSymbol)(Data_Symbol.SProxy.value)(value))(rest);
                                return result;
                            };
                        });
                    };
                };
            };
        };
    };
};
var applyEither = function (dictSemigroup) {
    return function (v) {
        return function (v1) {
            if (v instanceof Data_Either.Left && v1 instanceof Data_Either.Right) {
                return new Data_Either.Left(v.value0);
            };
            if (v instanceof Data_Either.Left && v1 instanceof Data_Either.Left) {
                return new Data_Either.Left(Data_Semigroup.append(dictSemigroup)(v.value0)(v1.value0));
            };
            if (v instanceof Data_Either.Right && v1 instanceof Data_Either.Left) {
                return new Data_Either.Left(v1.value0);
            };
            if (v instanceof Data_Either.Right && v1 instanceof Data_Either.Right) {
                return new Data_Either.Right(v.value0(v1.value0));
            };
            throw new Error("Failed pattern match at Simple.JSON (line 229, column 1 - line 229, column 90): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var exceptTApply = function (dictSemigroup) {
    return function (dictApplicative) {
        return function (fun) {
            return function (a) {
                return Control_Monad_Except_Trans.ExceptT(Control_Apply.apply(dictApplicative.Apply0())(Data_Functor.map((dictApplicative.Apply0()).Functor0())(applyEither(dictSemigroup))(Control_Monad_Except_Trans.runExceptT(fun)))(Control_Monad_Except_Trans.runExceptT(a)));
            };
        };
    };
};
var readFieldsCons = function (dictIsSymbol) {
    return function (dictReadForeign) {
        return function (dictReadForeignFields) {
            return function (dictLacks) {
                return function (dictCons) {
                    return new ReadForeignFields(function (v) {
                        return function (obj) {
                            var rest = getFields(dictReadForeignFields)(Type_Data_RowList.RLProxy.value)(obj);
                            var name = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                            var withExcept$prime = Control_Monad_Except.withExcept(Data_Functor.map(Data_List_Types.functorNonEmptyList)(Foreign.ErrorAtProperty.create(name)));
                            var first = Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(withExcept$prime(Control_Bind.bindFlipped(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(readImpl(dictReadForeign))(Foreign_Index.readProp(name)(obj))))(function (v1) {
                                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Record_Builder.insert(dictCons)(dictLacks)(dictIsSymbol)(Data_Symbol.SProxy.value)(v1));
                            });
                            return exceptTApply(Data_List_Types.semigroupNonEmptyList)(Data_Identity.applicativeIdentity)(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Control_Semigroupoid.compose(Record_Builder.semigroupoidBuilder))(first))(rest);
                        };
                    });
                };
            };
        };
    };
};
var readVariantCons = function (dictIsSymbol) {
    return function (dictReadForeign) {
        return function (dictCons) {
            return function (dictReadForeignVariant) {
                return new ReadForeignVariant(function (v) {
                    return function (o) {
                        var name = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                        return Control_Alt.alt(Control_Monad_Except_Trans.altExceptT(Data_List_Types.semigroupNonEmptyList)(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(readImpl(readRecord()(readFieldsCons(new Data_Symbol.IsSymbol(function () {
                            return "type";
                        }))(readString)(readFieldsCons(new Data_Symbol.IsSymbol(function () {
                            return "value";
                        }))(readForeign)(readFieldsNil)()())()()))(o))(function (v1) {
                            var $83 = v1.type === name;
                            if ($83) {
                                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(readImpl(dictReadForeign)(v1.value))(function (v2) {
                                    return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_Variant.inj(dictCons)(dictIsSymbol)(Data_Symbol.SProxy.value)(v2));
                                });
                            };
                            return Foreign.fail(Foreign.ForeignError.create("Did not match variant tag " + name));
                        }))(readVariantImpl(dictReadForeignVariant)(Type_Data_RowList.RLProxy.value)(o));
                    };
                });
            };
        };
    };
};
module.exports = {
    readJSON: readJSON,
    "readJSON'": readJSON$prime,
    readJSON_: readJSON_,
    writeJSON: writeJSON,
    write: write,
    read: read,
    "read'": read$prime,
    read_: read_,
    parseJSON: parseJSON,
    "undefined": $$undefined,
    ReadForeign: ReadForeign,
    readImpl: readImpl,
    ReadForeignFields: ReadForeignFields,
    getFields: getFields,
    ReadForeignVariant: ReadForeignVariant,
    readVariantImpl: readVariantImpl,
    WriteForeign: WriteForeign,
    writeImpl: writeImpl,
    WriteForeignFields: WriteForeignFields,
    writeImplFields: writeImplFields,
    WriteForeignVariant: WriteForeignVariant,
    writeVariantImpl: writeVariantImpl,
    readForeign: readForeign,
    readChar: readChar,
    readNumber: readNumber,
    readInt: readInt,
    readString: readString,
    readBoolean: readBoolean,
    readArray: readArray,
    readMaybe: readMaybe,
    readNullable: readNullable,
    readObject: readObject,
    readRecord: readRecord,
    readFieldsCons: readFieldsCons,
    readFieldsNil: readFieldsNil,
    readForeignVariant: readForeignVariant,
    readVariantNil: readVariantNil,
    readVariantCons: readVariantCons,
    writeForeignForeign: writeForeignForeign,
    writeForeignString: writeForeignString,
    writeForeignInt: writeForeignInt,
    writeForeignChar: writeForeignChar,
    writeForeignNumber: writeForeignNumber,
    writeForeignBoolean: writeForeignBoolean,
    writeForeignArray: writeForeignArray,
    writeForeignMaybe: writeForeignMaybe,
    writeForeignNullable: writeForeignNullable,
    writeForeignObject: writeForeignObject,
    recordWriteForeign: recordWriteForeign,
    consWriteForeignFields: consWriteForeignFields,
    nilWriteForeignFields: nilWriteForeignFields,
    writeForeignVariant: writeForeignVariant,
    nilWriteForeignVariant: nilWriteForeignVariant,
    consWriteForeignVariant: consWriteForeignVariant
};
